import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from '../pages/LoginPage';
import AdminRoutes from './AdminRoutes';
import CompanyRoutes from './CompanyRoutes';
import { useAuth } from '../context/AuthContext';

const AppRoutes = () => {
  const { isAuthenticated, role } = useAuth();

  // Redirect based on authentication status and role
  const getHomeRedirect = () => {
    if (!isAuthenticated) {
      return <Navigate to="/login" />;
    }
    
    if (role === 'admin') {
      return <Navigate to="/admin/dashboard" />;
    }
    
    if (role === 'company') {
      return <Navigate to="/company/profile" />;
    }
    
    return <Navigate to="/login" />;
  };

  return (
    <Routes>
      <Route path="/" element={getHomeRedirect()} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/*" element={<AdminRoutes />} />
      <Route path="/company/*" element={<CompanyRoutes />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default AppRoutes;
